

import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import useHttp from "../../../hooks/use-http";
import { endPoints } from "../../../config/end-points";
import { saveLocalData, fetchLocalData } from "../../../helpers/storage-helper";
import { authActions } from "../../../store/auth";

import { useDispatch, useSelector } from "react-redux";


import Loader from "../../UI/loader";



const CheckAuth = () => {
    
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const email = queryParams.get('email');
    const authToken = queryParams.get('authtoken');
    const app = queryParams.get('app');
    // const script_data = queryParams.get('script_data');
    const keyword = queryParams.get('keyword');
    const campid = queryParams.get('campid');
    const status = queryParams.get('status');
    const video_id = queryParams.get('video_id');

    const {sendRequest: verifytoken} = useHttp();

    const [logo, setLogo] = useState('');

    const loader = useSelector((state) => state.auth.loader);
    dispatch(
      authActions.setLoaderStatus({
        status: true,
        loader_text: "Authenticating...",
      })
    );


    useEffect(() => {
        if ( email && authToken && app) {


            if(app === 'vidwise'){
              setLogo('https://d37q3r06begyqi.cloudfront.net/VidAmaze/users/1/images/VSAILogoDarkBigV2.png');
            }else if(app === 'nicheflicks'){
              setLogo(`${process.env.PUBLIC_URL}/assets/images/nicheflicks-logo-black.png`);
            }
            
          
            
            dispatch(authActions.setLoaderStatus({ status: true }));
            // console.log(email+'|'+authToken);
            const user = fetchLocalData("vidamaze_user");
            if(!user){
              console.log('user1');
              authenticate({app, email, authToken})
            }else{

              console.log(video_id, status);
              
              if( video_id > 0 && status === "1" ){
                history.push("/campaign/"+video_id+"/edit");
                return;
              }

              if( video_id > 0 && status === "2" ){
                history.push("/render/"+video_id+"/");
                return;
              }

              console.log(campid);
              if( campid === null || campid === undefined || campid === '' ){
                history.push("/");
                return;
              }

              saveLocalData("keyword", keyword );
              saveLocalData("campid", campid );
              saveLocalData("app", app );

              get_script_data(campid, app);

              // let tempData = script_data;
              // tempData = tempData.replace(/['"]+/g, '');
              // tempData = atob(tempData);
              // // console.log(tempData)
              // tempData = JSON.parse(tempData);
              // // tempData = JSON.parse(tempData);
              // saveLocalData("script_data", tempData );

              
              // console.log('user');
              history.push("/create-campaign");
            }
            
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const responseHandle = (response) => {

      // console.log(response);
      if(response.status === 200){
        saveLocalData("vidamaze_user", response);


        if( video_id !== null && video_id !== undefined && video_id !== '' && status === '1' ){
          history.push("/campaign/"+video_id+"/edit");
          return;
        }

        if( video_id !== null && video_id !== undefined && video_id !== '' && status === '2' ){
          history.push("/render/"+video_id+"/");
          return;
        }

        console.log(campid);
        if( campid === null || campid === undefined || campid === '' ){
          history.push("/");
          return;
        }


        saveLocalData("keyword", keyword );
        saveLocalData("campid", campid );
        saveLocalData("app", app );

        // let tempData = script_data;
        // tempData = tempData.replace(/['"]+/g, '');
        // tempData = atob(tempData);
        // // console.log(tempData)
        // tempData = JSON.parse(tempData);
        // // tempData = JSON.parse(tempData);
        // saveLocalData("script_data", tempData );
        get_script_data(campid, app);

        dispatch(
          authActions.login({
            token: response.token,
            roles: response.roles,
            first_name: response.first_name,
            last_name: response.last_name,
            access: response.access,
            email: response.email,
            video_credits: response.video_credits,
          })
        );
        dispatch(authActions.setLoaderStatus({ status: false }));
        history.push("/create-campaign");
      }else{
        history.push("/login");
      }
        
    };

  const authenticate = (data) => {


    // console.log(data);
    verifytoken(
        {
          url: endPoints.verifytoken,
          method: "POST",
          headers: {
            "access-control-allow-origin": "*",
            "Content-Type": "application/json",
          },
          body: data,
        },
        responseHandle
      );
    
  };


  const get_script_data = (campid, app) => {

    let apiUrl = '';

    if( app === 'vidwise' ){
      apiUrl =  "https://vidwiseai.engageleads.net/get_video_script/" + campid;
      // apiUrl =  "http://localhost/github/vidwiseai/get_video_script/" + campid;
    }else if( app === 'nicheflicks' ){
      apiUrl =  "https://nicheflicks.engageleads.net/get_video_script/" + campid;
      // apiUrl =  "http://localhost/github/nicheflicks/get_video_script/" + campid;
    }else{
      apiUrl = '';
    }




    const responseHandle1 = (response) => {
      
      if(response){
        console.log(response);
        saveLocalData("script_data", response );
      }
    };
    verifytoken(
      {
        url: apiUrl,
        method: "GET",
        headers: { },
      },
      responseHandle1
    );
  };






  return (

    <>
      <style>
        {`
        .loader {
          background: #ffffff52!important;
          padding-top: 13%!important;
          }
          .authpage{
            height: 70vh;
          }
          .loader img
          {
              width: 250px;
          }
        
        `}
      </style>

      {/* <div className="text-center mt-5 pt-5"><h2>Authenticating...</h2></div> */}
      <div className="text-center mt-5 pt-5 authpage">
          { logo && <img src={logo} className="img-fluid max-250" alt="img" /> }
      </div>
      

      {loader && <Loader />}
    </>
    
    
  );
};

export default CheckAuth;
